import React, { Fragment } from 'react'

import Banner from './Banner'
import OurServices from './Content'

export default function ServicesPage() {
    return (
        <Fragment>
            <Banner />
            <OurServices />
        </Fragment>
    )
}
